import {useInfiniteQuery} from '@tanstack/react-query'
import {useContentstackRMS} from '../../../context/contentstack'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getEntriesWithFilterParams} from '../../../custom-api/api/contentstack/sdk/entry'
import {BRAND_KEY} from '../../../brand'

const FETCH_LIMIT = 12
export const useGetRecipesList = (selectedFilters) => {
    const {locale} = useMultiSite()
    const {stack} = useContentstackRMS()

    //use infinite tsukuyomi
    return useInfiniteQuery({
        queryKey: ['recipeListQuery', selectedFilters],
        queryFn: async ({pageParam = 1}) => {
            const response = await getEntriesWithFilterParams({
                stack,
                contentTypeUid: 'cooking_recipe',
                locale: locale.alias,
                from: (pageParam - 1) * FETCH_LIMIT,
                limit: FETCH_LIMIT,
                selectedFilters: selectedFilters ? selectedFilters : {},
                brand: BRAND_KEY,
            })
            return response
        },
        getNextPageParam: (lastPage, allPages) => {
            //console.log('all pages', allPages)
            return allPages.length + 1
        },
        keepPreviousData: true,
        staleTime: 1000 * 60 * 5,
        cacheTime: 1000 * 60 * 10,
        refetchOnWindowFocus: false,
    })
}
